import { render, staticRenderFns } from "./SampleSingle.vue?vue&type=template&id=218ea7fc"
import script from "./SampleSingle.vue?vue&type=script&lang=js"
export * from "./SampleSingle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports